module.exports = __webpack_public_path__ + "static/img/voibook2.eaf4467.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/voibook2.jpg
// module id = txda
// module chunks = 1